export function intFromString(int: string | undefined): number | undefined {
  if (int !== undefined) {
    return parseInt(int);
  }

  return undefined;
}
